var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-per100 column a-center",attrs:{"id":"app"}},[_c('FullScreenContainer',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }